<template>
  <v-dialog
    v-model="dialog"
    :width="participants.length == 0 ? '448' : '916'"
    open-on-focus
    no-click-animation
    persistent
    :content-class="
      participants.length == 0
        ? 'deactivation-pruser-dialog'
        : 'deactivation-pruser-dialog v-dialog-large'
    "
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card v-if="participants.length == 0">
      <v-card-title class="headline"
        >{{ user.isActive ? 'Dectivate' : 'Activate' }} user?</v-card-title
      >
      <v-card-text
        >As there are no assigned participants, you may
        {{ user.isActive ? 'deactivate' : 'activate' }} this user.
        Proceed?</v-card-text
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="rounded-pill" text @click="closeDialog()">Cancel</v-btn>
        <v-btn
          class="rounded-pill elevation-0"
          color="accent"
          @click="
            closeDialog()
            $emit('onSave')
          "
          >Confirm</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card class="sided" elevation="0" v-else>
      <v-toolbar flat height="76">
        <v-toolbar-title class="deactivation-pruser-toolbar-title"
          >User deactivation</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn color="accent" icon tile @click="closeDialog">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-subtitle
        >Before deactivation you need to reassign participants to other
        advisors.</v-card-subtitle
      >
      <div class="participants">
        <main-user-table
          :headers="headers"
          :items="participants"
          :items-per-page="queryParams.pageSize"
          :server-items-length="participantsPagination.totalCount || -1"
          :page="queryParams.page"
          :selectAdvisors="advisors"
          :currentAdvisor="currentAdvisor"
          v-on="$listeners"
          :row-component="'practice-user-patient-with-select-table-row'"
          @action:get-data="
            data =>
              user &&
              user.id &&
              getDataAction({ ...data, practiceUserId: user.id }, false)
          "
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MainUserTable from '@/components/tables/MainUserTable'
import RouterMixin from '@/mixins/router'

export default {
  name: 'PracticeUserDeactivationDialog',
  components: {
    MainUserTable,
  },
  mixins: [RouterMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    participants: {
      type: Array,
      default: () => [],
    },
    participantsPagination: {
      type: Object,
      default: () => {},
    },
    advisors: {
      type: Array,
      default: () => [],
    },
    currentAdvisor: {
      type: Object,
      default: () => {},
    },
    reloader: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      headers: [],
      dialog: false,
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
        if (this.user) {
          this.queryParams.page = 1
          this.getDataAction(
            { ...this.queryParams, sortBy: null, practiceUserId: val.id },
            false,
          )
        }
      } else {
        this.dialog = false
      }
    },
    user: function(val) {
      if (val.id && this.showDialog) {
        this.queryParams.page = 1
        this.getDataAction(
          { ...this.queryParams, sortBy: null, practiceUserId: val.id },
          false,
        )
      }
    },
    reloader: function(val) {
      if (val && this.dialog) {
        this.getPracticeUserPatients({
          ...this.queryParams,
          sortBy: null,
          practiceUserId: this.user.id,
          page: 0,
        })
      }
    },
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions('practicesStates', ['getPracticeUserPatients']),
    closeDialog() {
      this.dialog = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    getData(data = {}) {
      if (this.dialog) {
        if (data && data.delete && data.get('sortBy')) {
          data.delete('sortBy')
        }

        if (data instanceof URLSearchParams) {
          data.append('practiceUserId', this.user.id)
        } else {
          data.practiceUserId = this.user.id
        }

        this.getPracticeUserPatients(data)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.deactivation-pruser {
  &-dialog {
    margin: $gutter;
    max-height: calc(100% - #{2 * $gutter}) !important;
    &.v-dialog-large {
      margin-left: auto;
      height: 100%;
    }
    > .v-card {
      width: 100%;
      height: 100%;
    }
    > .v-card.sided {
      background-color: $bh-blue--4;
      overflow: auto;
    }
    .v-card__subtitle {
      padding: 8px 24px !important;
    }
    .participants {
      background: $bh-white;
      padding: 0 0.75 * $gutter;
      height: calc(100% - 120px);
      overflow: auto;
      &-breadcrumbs {
      }
      &-heading {
        color: $bh-gray--2;
        font-size: 1rem;
        padding-left: 8px;
      }
      &-folders {
        display: flex;
        flex-wrap: wrap;
      }
      &-files {
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
    padding-left: 5px;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-gray--2;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
}
</style>
